<template>
	<article class="d-find-by-code">
		<header>
			<h1
				v-if="title || name"
				class="text-[45px] mt-[35px] mb-[10px] font-light"
				v-html="title || name"
			></h1>
			<p
				v-if="teaser"
				class="text-22 <760:text-[14px] mt-[10px] mb-[20px]"
				v-html="teaser"
			></p>
		</header>

		<div v-if="mainForm" class="w-2/3 <760:w-full mt-[10px]">
			<div
				v-if="errorMessage"
				class="d-find-by-code__error p-[15px] bg-red text-white mb-[10px]"
			>
				{{ errorMessage }}
			</div>

			<FetchForm
				v-if="mainForm?.endpointUrl && !successMessage"
				:action="mainForm.endpointUrl"
				:method="mainForm.method"
				class="w-full p-[25px] bg-white text-16 text-text"
				use-native-form-data-on-post
				@submit="onSubmit"
				@error="onError"
				@response="onResponse"
			>
				<label
					v-if="mainForm.fieldByName.code?.label"
					for="ff-code"
					class="block text-16 mb-[10px]"
				>
					{{ mainForm.fieldByName.code?.label }}
				</label>
				<FormText
					v-if="mainForm.fieldByName.code"
					id="ff-code"
					v-model="text"
					:name="mainForm.fieldByName.code.name"
					:placeholder="mainForm.fieldByName.code.placeholder"
					required
					class="w-full"
				/>
				<div class="text-navy flex justify-end items-center mt-[10px]">
					<BaseButton
						v-if="mainForm.fieldsByType.submit?.[0]"
						type="submit"
					>
						{{ mainForm.fieldsByType.submit?.[0].name }}
					</BaseButton>
				</div>
			</FetchForm>
			<div
				v-else-if="successMessage"
				class="w-full p-[25px] bg-white text-16 text-text"
			>
				<div v-html="successMessage"></div>
			</div>
		</div>

		<BlockList
			:block-list="elements"
			class="w-full mt-[10px] grid grid-cols-1 gap-[10px]"
		/>
	</article>
</template>

<script setup>
const props = defineProps({
	id: Number,
	title: String,
	name: String,
	teaser: String,
	header: Object,
	elements: Array,
	forms: Array,
	links: Array,
});
const mainForm = ref(
	props.forms?.length
		? useLimboForm(props.forms[0], { populateFromQuery: true })
		: null
);
</script>
<script>
export default {
	inheritAttrs: false,
	data() {
		return {
			mainForm: this._.setupState.mainForm,
			text: this.$route.query.code || '',
			submittedText: null,
			errorMessage: null,
			successMessage: null,
			action: null,
		};
	},
	mounted() {
		this.action = this.forms?.[0]?.endpointUrl;

		// Start with a search
		// Depending on how things work, we might just need to set an error message directly
		if (this.mainForm?.endpointUrl && this.$route.query.code) {
			const body = new FormData();
			body.append('code', this.$route.query.code);

			this.onSubmit();
			$fetch(this.mainForm.endpointUrl, {
				method: this.mainForm.method,
				body,
			})
				.then(this.onResponse)
				.catch(this.onError);
		}
	},
	methods: {
		onSubmit() {
			this.errorMessage = null;
			this.submittedText = this.text;
		},
		onResponse({ redirectUrl }) {
			if (redirectUrl) {
				this.$router.push(redirectUrl);
			} else {
				onError();
			}
		},
		onError(error) {
			console.dir(error);
			this.errorMessage = `Behandlingsnummer (${this.submittedText}) kan ikke findes`;
		},
	},
};
</script>

<style lang="postcss">
.d-find-by-code {
	@apply text-white flex flex-col justify-center w-full max-w-layout-max pb-[80px] mx-auto px-layout-margin;
	&__error {
		background-image: linear-gradient(#9e0b06, #b7312c);
	}
	a {
		border-bottom: 1px solid rgba(0, 51, 73, 0.4);
		transition: color 0.3s, border 0.3s;

		&:hover {
			color: rgba(0, 51, 73, 0.8);
			border-color: rgba(0, 51, 73, 0.2);
		}
	}
}
</style>
